export enum ContentTypesEnum {
  CATEGORY = 'api::category.category',
  DATA_SOURCE = 'api::data-source.data-source',
  STATS = 'api::statistic.statistic',
  STUDY = 'api::study.study',
  REDIRECTION = 'api::redirection.redirection',
  CONTACT_CATEGORY = 'api::contact-category.contact-category',
}
